'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import { useSiteStore } from '@/store/site';

const ExchangeModal = dynamic(
	() => import('./exchange-modal').then(m => m.ExchangeModal),
	{ ssr: false }
);

export const ExchangeModalLoader = () => {
	const isOpenExchange = useSiteStore(state => state.isOpenExchange);
	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		if (isOpenExchange) {
			setShouldRender(true);
		}
	}, [isOpenExchange]);

	if (!shouldRender) {
		return null;
	}

	return <ExchangeModal />;
};